import React from "react";
import { Typography, Paper, Box, IconButton, Skeleton } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Droppable, Draggable } from "react-beautiful-dnd";

export default function KanbanColumn({
  status,
  selectedStatus,
  groupedAudits,
  isLoading,
  handleCardClick,
  handleMenuOpen,
}) {
  return (
    <Box
      key={status.id}
      sx={{
        flex: "0 0 300px",
        borderRadius: 0,
        boxShadow: "none",
        minHeight: "800px",
        maxHeight: "800px",
        overflowY: "auto",
        bgcolor: "#fff",
        display:
          selectedStatus === null || selectedStatus === status.name
            ? "block"
            : "none",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          textAlign: "center",
          color: "black",
          fontWeight: "bold",
          borderTop: "3px solid #3ed6e7",
          p: 1,
          borderRadius: 1,
          bgcolor: status.bgColor,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "0.875rem",
        }}
      >
        {status.name}
        <Box
          sx={{
            backgroundColor: "white",
            color: "black",
            borderRadius: "50%",

            width: 24,
            height: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "0.8rem",
            fontWeight: "bold",
          }}
        >
          {groupedAudits[status.name]?.length || 0}
        </Box>
      </Typography>
      <Droppable droppableId={status.name}>
        {(provided, snapshot) => (
          <Box
            ref={provided.innerRef}
            {...provided.droppableProps}
            sx={{
              minHeight: "calc(800px - 60px)",
              backgroundColor: snapshot.isDraggingOver
                ? status.bgColor + "80"
                : "transparent",
              transition: "background-color 0.2s ease",
              padding: 1,
            }}
          >
            {isLoading && groupedAudits[status.name]?.length === 0
              ? [1, 2].map((idx) => (
                  <Skeleton
                    key={`loading-${status.name}-${idx}`}
                    variant="rectangular"
                    height={80}
                    sx={{ mb: 2, mx: 1 }}
                  />
                ))
              : groupedAudits[status.name]?.map((audit, index) => (
                  <Draggable
                    key={audit.id}
                    draggableId={audit.id}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <Paper
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        sx={{
                          mb: 2,
                          p: 2,
                          mx: 1,
                          cursor: "pointer",
                          position: "relative",
                          boxShadow: snapshot.isDragging ? 4 : 1,
                          borderLeft: `4px solid ${status.color}`,
                          transform: snapshot.isDragging
                            ? "rotate(2deg)"
                            : "none",
                        }}
                        onClick={() => handleCardClick(audit, status.name)}
                      >
                        <Typography variant="subtitle1">
                          {audit.title || "Untitled"}
                        </Typography>
                        <Typography variant="body2">
                          {audit.recordStage || "Unknown"}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {audit.date !== "Unknown"
                            ? new Date(audit.date).toLocaleDateString()
                            : "Unknown Date"}
                        </Typography>
                        <IconButton
                          sx={{ position: "absolute", top: 8, right: 8 }}
                          onClick={(e) => handleMenuOpen(e, audit)}
                        >
                          <MoreHorizIcon />
                        </IconButton>
                      </Paper>
                    )}
                  </Draggable>
                ))}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </Box>
  );
}
